import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
import { Button } from "./Button.js";
/**
 * Cursor-based pagination — matches the API contract from
 * `packages/shared-types/src/pagination.ts`: `{ items, nextCursor }`.
 * V1.0 ships prev/next only — page numbers + jump-to-page deferred.
 */
export function Pagination({ hasPrev, hasNext, onPrev, onNext, className }) {
    return (_jsxs("nav", { "data-slot": "pagination", className: cn("flex items-center justify-end gap-2", className), "aria-label": "Pagination", children: [_jsx(Button, { variant: "secondary", size: "sm", icon: "chevronLeft", disabled: !hasPrev, onClick: onPrev, children: "Previous" }), _jsx(Button, { variant: "secondary", size: "sm", iconRight: "chevronRight", disabled: !hasNext, onClick: onNext, children: "Next" })] }));
}
